import Vue from 'vue';

const userContextsLiteModule = {
  //  Easy VUEX firestore configuration
  firestorePath: 'userContextsLite',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'userContextsLite',
  statePropName: 'userContextsLiteData',
  namespaced: true, // automatically added
  state: {},
  getters: {
    // contextsLite: state => {
    //   if (!state.userContextsLiteData) {
    //     return undefined;
    //   }
    //   const returnObj = {};
    //   Object.values(state.userContextsLiteData).forEach(userContextsLiteDoc => {
    //     Object.values(userContextsLiteDoc.contexts).forEach(context => {
    //       returnObj[context.id] = context;
    //     });
    //   });
    //   return returnObj;
    // },
    // contextLiteWorkspaces: state => {
    //   if (!state.userContextsLiteData) {
    //     return undefined;
    //   }
    //   const returnObj = {};
    //   Object.values(state.userContextsLiteData).forEach(userContextsLiteDoc => {
    //     Object.values(userContextsLiteDoc.workspaces).forEach(workspace => {
    //       returnObj[workspace.id] = workspace;
    //     });
    //   });
    //   return returnObj;
    // },
    // contextLiteToUpdate: state => {
    //   const contextsPerDocument = 500;
    //   const sortedAndFiltered = Object.values(state.userContextsLiteData)
    //     .sort((a, b) => a.createdOn - b.createdOn)
    //     .filter(document => {
    //       const contextLites = Object.keys(document.contexts);
    //       return contextLites.length < contextsPerDocument;
    //     });
    //   if (sortedAndFiltered.length === 0) {
    //     return null;
    //   } else {
    //     return sortedAndFiltered[0].id;
    //   }
    // }
  },
  mutations: {
    addNewContextLite(state, { contextLiteId, doc }) {
      try {
        Vue.set(state.userContextsLiteData[contextLiteId].contexts, doc.id, doc);
      } catch (e) {
        console.log(
          'could not update vuex probably the useercontextslite document does not yet exist'
        );
      }
    },
    removeContextLite(state, { contextLiteId, docId }) {
      Vue.delete(state.userContextsLiteData[contextLiteId].contexts, docId);
    }
  },
  actions: {
    subscribeToUserContextsLite({ dispatch, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        //get userId and throw an error if there are any problems getting the user ID
        if (!rootGetters['auth/isUser']) {
          reject('auth/isUser is set to false');
        }
        const userId = rootGetters['auth/userId'];

        try {
          await dispatch('openDBChannel', {
            where: [['userId', '==', userId]]
          });
          resolve('subscribed to userContextsLite');
        } catch (e) {
          reject(e);
        }
      });
    },
    unsubscribeToUserContextsLite({ dispatch }) {
      console.log('unsubscribe for userContextsLite');
      dispatch('closeDBChannel', { clearModule: true });
    },
    addNewContextLiteVuexOnly({ commit, getters }, { doc }) {
      const contextLiteId = getters.contextLiteToUpdate;
      if (contextLiteId !== null) {
        commit('addNewContextLite', { doc, contextLiteId });
      }
    },
    removeContextLiteVuexOnly({ state, commit }, { docId }) {
      const { userContextsLiteData } = state;
      const contextLiteDocKeys = Object.keys(userContextsLiteData);
      let contextLiteId = null;
      contextLiteDocKeys.forEach(key => {
        let { contexts } = userContextsLiteData[key];
        if (Object.keys(contexts).includes(docId)) {
          contextLiteId = key;
        }
      });
      if (contextLiteId !== null) {
        commit('removeContextLite', { docId, contextLiteId });
      }
    }
  }
};

export default userContextsLiteModule;
